import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { JioPay } from '../assets/images/svg/JioPay'
import { useStores } from '../data/store'
import { convertHexToRGBA } from '../utils'
import { staticStrings } from '../utils/string'

const TOneFooter = (props: any) => {
  const { merchantTheme } = useStores((root) => ({
    merchantTheme: root?.config?.merchantTheme,
  }))
  // const footerBgColor = convertHexToRGBA(merchantTheme?.brandColor, 10)
  // const textColor = merchantTheme?.bodyTextColor
  const responsiveStyles = styles(merchantTheme)
  return (
    <Box
      testID="footerTest"
      {...(props?.isBottomAligned
        ? { ...responsiveStyles.containerViewBottomWrapped }
        : { ...responsiveStyles.containerView })}>
      <Box {...responsiveStyles.poweredBy}>
        <Text {...responsiveStyles.poweredByInner}>{staticStrings.poweredBy}</Text>
        <Spacer size={8} direction={'horizontal'} />
        <JioPay width={20} height={20} />
      </Box>
    </Box>
  )
}

const commonContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
  position: 'relative',
} as BoxProps

const styles = (merchantTheme: any) => {
  const direction = { flexDirection: 'column-reverse' } as BoxProps

  return {
    containerView: {
      ...commonContainerStyle,
      ...direction,
    } as BoxProps,
    containerViewBottomWrapped: {
      ...commonContainerStyle,
      ...direction,
      paddingVertical: 16,
      position: 'absolute',
      bottom: 0,
    } as BoxProps,
    imageContainer: {
      flex: 1,
      flexDirection: 'row',
      marginVertical: 10,
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingHorizontal: 'SMALL',
      minHeight: 12,
    } as BoxProps,
    imageView: {
      paddingRight: 60,
      height: 16,
      width: 44,
    },
    poweredBy: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingHorizontal: 'SMALL',
      paddingVertical: 8,
      minHeight: 12,
    } as BoxProps,
    poweredByInner: {
      color: convertHexToRGBA(merchantTheme?.bodyTextColor, 50) as ColorOptions,
      fontSize: 10,
      fontWeight: '500',
    } as TextProps,
    jiomoneyText: {
      color: 'PRIMARY',
      fontSize: 12,
      fontWeight: '700',
      fontFamily: 'jioType-Medium',
    } as TextProps,
    alignHorizontal: {
      flexDirection: 'row',
    } as BoxProps,
    alignVertical: {
      flexDirection: 'column',
      border: 'solid 1px',
    } as BoxProps,
  }
}

export default TOneFooter
